import type { TriggerSummary } from "@/api/workflow-insights";
import { cronToShortText } from "@/lib/cron-text";

/** "Channel · #support", "Schedule · daily 02:00", "Webhook", "Manual", "Email". */
export function triggerLabel(t: TriggerSummary | null | undefined): string {
  if (!t) return "Manual";
  switch (t.subtype) {
    case "schedule":
      return t.cronExpression ? `Schedule · ${cronToShortText(t.cronExpression)}` : "Schedule";
    case "webhook":
      return "Webhook";
    case "channel_message":
      return t.channelName ? `Channel · #${t.channelName}` : "Channel";
    case "outlook_email":
    case "email":
      return "Email";
    case "manual":
    default:
      return t.subtype && t.subtype !== "manual"
        ? t.subtype.charAt(0).toUpperCase() + t.subtype.slice(1).replace(/_/g, " ")
        : "Manual";
  }
}

/** Sentence form for the drill-in node chain: "Channel message in #support". */
export function triggerSentence(t: TriggerSummary | null | undefined): { text: string; strong?: string } {
  if (!t) return { text: "Manual run" };
  switch (t.subtype) {
    case "schedule":
      return { text: "Schedule ", strong: t.cronExpression ? cronToShortText(t.cronExpression) : undefined };
    case "webhook":
      return { text: "Inbound webhook" };
    case "channel_message":
      return { text: "Channel message in ", strong: t.channelName ? `#${t.channelName}` : "a channel" };
    case "outlook_email":
    case "email":
      return { text: "Inbound email" };
    default:
      return { text: t.label ?? "Manual run" };
  }
}
